import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Container, Button, Grid } from '@material-ui/core'

import { useStyleContext } from 'contexts/StyleContext/useStyleContext'
import { Header } from 'components'

import { useStyles } from './styles'

const Home: React.FC = () => {
  const classes = useStyles()
  const navigate = useNavigate()

  const [, setLogoUrl] = useState('')

  const { style, getFromStorage, isLoadingStyle } = useStyleContext()

  useEffect(() => {
    const applyLogo = async () => {
      if (style) {
        setLogoUrl(style.storeLogoUrl)
      } else {
        const styleUpdate = await getFromStorage()
        if (styleUpdate) setLogoUrl(styleUpdate.storeLogoUrl)
      }
    }
    applyLogo()
  }, [isLoadingStyle])

  return (
    <Container className={classes.container} maxWidth={false}>
      <Header hideLogo={false} showRightButton={false} showBackButton={false} />
      <Grid container spacing={1} direction="column" justify="center" alignItems="center">
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            disableElevation
            onClick={() => navigate('/reader')}
          >
            Escanear código QR
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            disableElevation
            onClick={() => navigate('/code')}
          >
            Ingresar código
          </Button>
        </Grid>
      </Grid>
    </Container>
  )
}

export { Home }
